import { Link } from "react-router-dom";
import SteelcaseImage from "../layout/SteelcaseImage/SteelcaseImage";

export interface PaletteCardProps {
    id: string;
    title: string;
    description: string;
    imageURL: string;
    altText: string;
    postLink: string;
    routerValue: string;
}

export default function PaletteCard({ id, title, description, imageURL, altText, postLink, routerValue }: PaletteCardProps) {
    return (
        <div className={"pallete-card__container"}>
            <div className={"pallete-card__image"}>
                <Link to={`../palettes/${routerValue}`} style={{ textDecoration: "none" }}>
                    <SteelcaseImage src={imageURL} altText={altText} />
                </Link>
            </div>
            <div className={"pallete-card__card-content"}>
                <Link to={`../palettes/${routerValue}`} style={{ textDecoration: "none" }}>
                    <div className={"pallete-card__card-content-name"}>{title}</div>
                </Link>
                <div className={"pallete-card__card-content-description"}>{description}</div>
            </div>
        </div>
    )
}